var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDesc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 2a1 1 0 110-2h6a1 1 0 110 2h-6zM3.982 10.493L1.79 8.306a1.05 1.05 0 00-1.483 0c-.41.409-.41 1.07 0 1.478l3.924 3.914c.211.213.491.309.769.302a1.04 1.04 0 00.77-.302l3.923-3.914c.41-.408.41-1.07 0-1.478a1.05 1.05 0 00-1.483 0L5.982 10.53V1a1 1 0 00-2 0v9.493zM12 5a1 1 0 001 1h3a1 1 0 100-2h-3a1 1 0 00-1 1zM13 10a1 1 0 110-2h1a1 1 0 110 2h-1z",
    fill: "#42ABE9"
  })));
}
export default SvgDesc;